import { AsyncButton, AsyncButtonProps } from "src/components/common/buttons/AsyncButton.tsx";
import { useGenericDialog } from "src/components/common/dialogs/GenericDialogContext.ts";
import i18n from "i18next";
import { faProjectDiagram } from "@fortawesome/pro-regular-svg-icons";
import { ProjectActivityApi } from "src/api/generated/erp/project/projectActivity/api/projectActivityApi.ts";
import { ProjectActivitiesContainerView } from "src/components/views/erp/project/projectActivity/ProjectActivitiesContainerView.tsx";
import { resolveValueOrProvider, ValueOrProvider } from "src/utils/valueOrProvider.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface OpenProjectActivityButtonProps extends Omit<AsyncButtonProps, "onClick"> {
	projectActivityId: ValueOrProvider<number | Promise<number>> | null | undefined;
}

export const OpenProjectActivityButton = ({
	projectActivityId,
	variant = "menu",
	...other
}: OpenProjectActivityButtonProps) => {
	const { openDialog } = useGenericDialog();
	if (projectActivityId == null) return null;
	return (
		<AsyncButton
			label={i18n.t("open_project_activity")}
			icon={faProjectDiagram}
			variant={variant}
			onClick={async () => {
				const projectActivity = await ProjectActivityApi.getSingleActivity({
					activityId: await resolveValueOrProvider(projectActivityId),
				});
				openDialog({
					title: i18n.t("project_activity"),
					agentContext: {
						key: defineAgentUiContextKey("erp.project.projectActivity.openProjectActivityButton.dialog"),
						data: { projectActivityId: projectActivity.activityId },
						pathSegments: [`${i18n.t("project_activity")} ${projectActivity.activityId}`],
					},
					content: (
						<ProjectActivitiesContainerView
							subProjectOrActivityId={{ type: "activity", id: projectActivity.activityId }}
						/>
					),
				});
			}}
			{...other}
		/>
	);
};
